import { SimulatePriceRequest } from 'features/simulation/types'
import { COUNTER_TYPES, EL_PRODUCT_CODES } from '@boltenergy-be/shared'
import { convertInjectionToAmountOfSolarPanels } from 'utils/conversion'

export const MIN_INJECTION = 100
export const MAX_SLIDER_INPUT = 5_000
export const MAX_INPUT = 10_000
export const INJECTION_STEP = 100
export const DEFAULT_INJECTION = 2_000

export const DEFAULT_PANELS = convertInjectionToAmountOfSolarPanels(DEFAULT_INJECTION)
export const MIN_PANELS = 1
export const MAX_PANELS = convertInjectionToAmountOfSolarPanels(MAX_INPUT)

export const INJECTION_ROI_MULTIPLIER = 1.2 // Additional discount to show the best possible price
export const BASE_SIMULATION_PRICE_REQUEST: Omit<SimulatePriceRequest, 'meterUsage'> = {
  deliveryPoint: {
    postalCode: '2000',
    townCode: '1',
    townName: 'Antwerpen'
  },
  counterType: COUNTER_TYPES.digital,
  hasSolarPanels: true,
  isCompany: false,
  product: {
    electricity: EL_PRODUCT_CODES.VariableOff
  }
}
